import {Component} from "@angular/core";

@Component({
    selector: "fhm-nav-layout",
    styleUrls: ["./nav-layout.component.scss"],
    templateUrl: "./nav-layout.component.html",
    standalone: false
})
export class NavLayoutComponent {
    constructor() {

    }
}
